<template>
    <main-container class="convention-ca">
        <v-row>
            <convention-ca-table-of-contents :convention="convention" class="convention-ca-table-of-contents" />
            <v-col>
                <v-container class="heading" v-if="convention.caMeta && convention.caMeta.heading">
                    <convention-body id="heading" :body="convention.caMeta.heading" />
                </v-container>
                <v-container class="main" v-if="territories">
                    <v-card elevation="3">
                        <v-row no-gutters>
                            <v-col class="body">
                                <convention-title id="territorial" type="h1" :title="dico.territorial" />
                                <convention-ca-territory
                                    v-for="territory in convention.territories"
                                    :territory="territory"
                                    :key="territory._uid"
                                    :territories="territories"
                                />
                            </v-col>
                        </v-row>
                    </v-card>
                </v-container>
                <v-container class="main" v-if="apenafs">
                    <v-card elevation="3">
                        <v-row no-gutters>
                            <v-col class="body">
                                <convention-title id="activities" type="h1" :title="dico.pro" />
                                <convention-ca-activity
                                    v-for="activity in convention.activities"
                                    :excludedActivitiesCodes="convention.excludedActivityCodes"
                                    :activity="activity"
                                    :key="activity._uid"
                                    :apenafs="apenafs"
                                />
                            </v-col>
                        </v-row>
                    </v-card>
                </v-container>
                <v-container id="exclusion" class="main" v-if="hasExcludedActivities">
                    <v-card elevation="3">
                        <v-row no-gutters>
                            <v-col class="body">
                                <convention-title id="excludedActivities" type="h1" title="Exclusions" />
                                <convention-ca-activity
                                    v-for="activity in convention.excludedActivities"
                                    :activity="activity"
                                    :key="activity._uid"
                                    :apenafs="apenafs"
                                />
                            </v-col>
                        </v-row>
                    </v-card>
                </v-container>
                <v-container class="annex" v-if="convention.caMeta && convention.caMeta.annex">
                    <convention-body id="annex" :body="convention.caMeta.annex" />
                </v-container>
            </v-col>
        </v-row>
    </main-container>
</template>

<script>
import ConventionCaActivity from "./ConventionCaActivity.vue";
import ConventionCaTerritory from "./ConventionCaTerritory.vue";
import ConventionTitle from "src/components/convention/ConventionTitle.vue";
import ConventionBody from "src/components/convention/ConventionBody.vue";
import ConventionCaTableOfContents from "./table-of-contents/ConventionCaTableOfContents";
import { Services } from "src/services/Services";
import { isArray, keyBy } from "lodash";

export default {
    components: {
        ConventionBody,
        ConventionTitle,
        ConventionCaTerritory,
        ConventionCaActivity,
        ConventionCaTableOfContents,
    },
    props: ["convention"],
    computed: {
        dico() {
            return this.$privateDico.convention.ca;
        },
        hasExcludedActivities() {
            return (
                this.apenafs &&
                isArray(this.convention.excludedActivities) &&
                this.convention.excludedActivities.length > 0
            );
        },
    },
    asyncComputed: {
        async territories() {
            const territories = await Services.api.ca.getAllTerritories();
            return keyBy(territories, "code");
        },
        async apenafs() {
            return Services.api.ca.getAllApenafs();
        },
    },
};
</script>

<style scoped lang="sass">
.heading
    background: $color-background
    padding: $grid-gutter

.annex
    background: $color-background
    padding: $grid-gutter  $grid-gutter * 3 $grid-gutter * 3

.main
    padding-left: 0
    padding-right: 0

.body
    padding: 0 $grid-gutter * 3 $grid-gutter * 3 $grid-gutter * 3

@media print
    .convention-ca-table-of-contents
        display: none
    .convention-ca
        padding: 0

    .heading
        margin-top: 8mm
        background-color: transparent
        padding: 0

        ::v-deep .cc-body
            margin-left: 0

    .main
        padding: 0

    .v-sheet
        box-shadow: none !important
        bortder: none

    .body
        padding: 0
</style>
